module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "centerdiv"
  }, [_c('h2', [_vm._v("《数学长征管理端》")]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.getMsg)
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('el-button', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getTjInfo
    }
  }, [_vm._v("刷新统计--数学长征")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('el-row', [_c('label', [_vm._v(_vm._s(_vm.userCount))]), _c('br'), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.rechargeNum))]), _c('br'), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.consumeToday))]), _c('br'), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.consumeAll))]), _c('br'), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.shareToday))]), _c('br'), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.shareAll))]), _c('br'), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.userProblemCount))]), _c('br'), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.loginUCToday))]), _c('br'), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.loginUCMonth))]), _c('br')])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('el-button', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getTjInfoFh
    }
  }, [_vm._v("刷新统计--烽火数学")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('el-row', [_c('label', [_vm._v(_vm._s(_vm.onLineUserCount))]), _c('br'), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.roomCount))]), _c('br'), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.ppGameUsers))]), _c('br'), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.onLineUsers))]), _c('br')])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-17fbb784"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/welcome.vue
// module id = 633
// module chunks = 8